
import { Component, Vue, Prop, Ref, Watch } from "vue-property-decorator";
import { PanelSize } from "@/views/sidebar/sidebar.types";

@Component
export default class SideMenuLayout extends Vue {
  @Prop({ type: String, default: PanelSize.sm })
  readonly size!: string;
  @Prop({ type: Boolean, default: false })
  readonly reloadOnClose!: boolean;
  @Prop({ type: String, default: "45%" })
  readonly closeButtonWidth!: string;
  @Prop({ type: Boolean, default: false })
  readonly clearExpandedRows!: boolean;
  @Prop({ type: String, default: "success" })
  readonly alertVariant!: string;
  @Prop({ type: Boolean, default: false })
  readonly alertVisible!: boolean;

  @Ref()
  readonly container!: HTMLElement;

  get sidebarUsingHistory() {
    return this.$sidebar.state && this.$sidebar.state.useHistory;
  }

  mounted() {
    this.$sidebar.size = this.size;
  }

  showAlert() {
    this.$emit('update:alertVisible', true);
    setTimeout(() => {
      this.$emit('update:alertVisible', false);
    }, 5000);
  }

  closeMenu() {
    const options = {
      success: false,
      reload: false,
    };

    if (this.reloadOnClose) {
      options.reload = true;
    }

    this.$sidebar.close(options);
  }
}
